import React, { useState } from "react";
import styles from "./your-birthtime.module.css";
import { Page } from "../../components/page/page";
import { Link } from "react-router-dom";
import { DateTimeButton } from "../../../../components/date-time-button/date-time-button";
import { useDispatch, useSelector } from "react-redux";
import { setBirthTime } from "../../store/stateSlice";

const leftFillNum = (num, targetLength) => {
  return num.toString().padStart(targetLength, "0");
}

const YourBirthTimePage = () => {
  const state = useSelector(store => store.dateBirth);
  const dispatch = useDispatch();
  const [selectedHour, selectHour] = useState(state.birthTime.hour || 12);
  const [selectedMinute, selectMinute] = useState(state.birthTime.minute || 0);
  const [selectedPeriod, selectPeriod] = useState(state.birthTime.period || "AM");

  const dateTimeButtonStyles = {
    borderColor: '#51bddb'
  }

  return (
    <Page
      title="What is your time of birth?"
      nextPageLink="../your-zodiac"
      onContinue={() =>
        dispatch(
          setBirthTime({
            hour: parseInt(selectedHour),
            minute: parseInt(selectedMinute),
            period: selectedPeriod,
          })
        )
      }
      currentStep={4}
    >
      <div>
        <div className={styles.buttons_flex_container}>
          <div className={styles.time_button_container}>
            <DateTimeButton styles={styles.button} value={selectedHour} dateTimeButtonStyles={dateTimeButtonStyles} onChange={(e) => selectHour(e.target.value)}>
              {[...Array(12)].map((el, i) => (
                <option value={leftFillNum(i + 1, 2)}>{leftFillNum(i + 1, 2)}</option>
              ))}
            </DateTimeButton>
          </div>
          <div className={styles.time_button_container}>
            <DateTimeButton styles={styles.button} value={selectedMinute} dateTimeButtonStyles={dateTimeButtonStyles} onChange={(e) => selectMinute(e.target.value)}>
              {[...Array(60)].map((el, i) => (
                <option value={leftFillNum(i, 2)}>{leftFillNum(i, 2)}</option>
              ))}
            </DateTimeButton>
          </div>
          <div className={styles.time_button_container}>
            <DateTimeButton styles={styles.button} value={selectedPeriod} dateTimeButtonStyles={dateTimeButtonStyles} onChange={(e) => selectPeriod(e.target.value)}>
              <option>AM</option>
              <option>PM</option>
            </DateTimeButton>
          </div>
        </div>
        <Link to="../your-gender">
          <p className={styles.time_link}>I don't know</p>
        </Link>
      </div>
    </Page>
  );
};

export { YourBirthTimePage };
